module.exports = __webpack_public_path__ + "img/pointer.1b6bf1fe.png";